@if (count !== undefined && count !== null) {
  <div
    class="__circle __circle--count"
    [matTooltip]="tooltip"
    [matTooltipDisabled]="!tooltip"
    [matTooltipClass]="tooltipClass"
    [ngStyle]="{
      'height.px': size,
      'lineHeight.px': size,
      'width.px': size,
      'borderRadius.px': size,
      'backgroundColor': color,
      'fontSize.px': fontSize || size * 0.6
    }">
    {{ count }}
  </div>
} @else {
  <div
    class="__circle"
    [matTooltip]="tooltip"
    [matTooltipDisabled]="!tooltip"
    [matTooltipClass]="tooltipClass"
    [ngStyle]="{
      'height.px': size,
      'lineHeight.px': size,
      'width.px': size,
      'borderRadius.px': size,
      'backgroundColor': color
    }">
  </div>

  @if (text) {
    <div
      [style.fontSize.px]="fontSize"
      class="__status">
      {{ text }}
    </div>
  }
}
